"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _react = _interopRequireWildcard(require("react"));
var _locale = require("../locale");
var _parseConfig = require("../utils/parse-config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var JSONEditor = /*#__PURE__*/_react.default.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./JSONEditor"));
  });
});
var EditorModal = function EditorModal(_ref) {
  var open = _ref.open,
    onCancel = _ref.onCancel,
    onOk = _ref.onOk,
    theme = _ref.theme;
  var locale = (0, _locale.useLocale)();
  var _message$useMessage = _antd.message.useMessage(),
    _message$useMessage2 = (0, _slicedToArray2.default)(_message$useMessage, 2),
    messageApi = _message$useMessage2[0],
    contextHolder = _message$useMessage2[1];
  var _antdTheme$useToken = _antd.theme.useToken(),
    token = _antdTheme$useToken.token;
  var _useState = (0, _react.useState)({
      text: JSON.stringify((0, _parseConfig.parsePlainConfig)(theme === null || theme === void 0 ? void 0 : theme.config), null, 2),
      json: undefined
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    content = _useState2[0],
    setContent = _useState2[1];
  (0, _react.useEffect)(function () {
    setContent({
      text: JSON.stringify((0, _parseConfig.parsePlainConfig)(theme === null || theme === void 0 ? void 0 : theme.config), null, 2)
    });
  }, [theme]);
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    editThemeFormatRight = _useState4[0],
    setEditThemeFormatRight = _useState4[1];
  var handleChange = function handleChange(newContent, preContent, status) {
    setContent(newContent);
    if (status !== null && status !== void 0 && status.contentErrors && Object.keys(status.contentErrors).length > 0) {
      setEditThemeFormatRight(false);
    } else {
      setEditThemeFormatRight(true);
    }
  };
  var handleDownload = function handleDownload() {
    var file = new File(["".concat(content === null || content === void 0 ? void 0 : content.text)], "theme.json", {
      type: 'text/json; charset=utf-8;'
    });
    var tmpLink = document.createElement('a');
    var objectUrl = URL.createObjectURL(file);
    tmpLink.href = objectUrl;
    tmpLink.download = file.name;
    document.body.appendChild(tmpLink);
    tmpLink.click();
    document.body.removeChild(tmpLink);
    URL.revokeObjectURL(objectUrl);
  };
  var handleOk = function handleOk() {
    if (!editThemeFormatRight) {
      messageApi.error('主题 JSON 格式错误');
      return;
    }
    onOk === null || onOk === void 0 || onOk((0, _parseConfig.parseThemeConfig)(JSON.parse(content.text)));
  };
  var handleUpload = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
      var _file$originFileObj;
      var fileList, _fileList, file, json;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fileList = _ref2.fileList;
            _fileList = (0, _slicedToArray2.default)(fileList, 1), file = _fileList[0];
            _context.next = 4;
            return (_file$originFileObj = file.originFileObj) === null || _file$originFileObj === void 0 ? void 0 : _file$originFileObj.text();
          case 4:
            json = _context.sent;
            setContent({
              text: json
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUpload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, contextHolder, /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: locale.themeConfig,
    open: open,
    onOk: handleOk,
    onCancel: onCancel,
    width: 800
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: token.colorTextDescription,
      marginBottom: 12
    }
  }, locale.algorithmTip), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement(_antd.Skeleton, null)
  }, /*#__PURE__*/_react.default.createElement(JSONEditor, {
    content: content,
    onChange: handleChange,
    mainMenuBar: false
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: -44,
      marginTop: 24
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Upload, {
    customRequest: function customRequest() {},
    maxCount: 1,
    showUploadList: false,
    accept: ".json",
    onChange: handleUpload
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.ImportOutlined, null),
    style: {
      marginRight: 8
    }
  }, locale.import)), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.ExportOutlined, null),
    onClick: handleDownload
  }, locale.export))));
};
var _default = exports.default = EditorModal;